export default __webpack_public_path__ + "static/media/gate.5bdd4faf.svg";